.icon {
	@apply yst-inline-block yst-w-3 yst-h-3 yst-ml-1.5;
}
